import React, { useEffect, useState } from "react";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import Scrollbar from "react-scrollbars-custom";
import NetThrivingScoreStatsDetailsPerUser from "./NetThrivingScoreStatsDetailsPerUser";
import NetThrivingScoreStatsHeaderCard from "./NetThrivingScoreStatsHeaderCard";
import EngagementPoint from "./EngagementPoint";
const styles = {
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};
export default ({ opened, team_id, stats }) => {
  const classes = styles;
  const [loading, setLoading] = useState(true);
  const [netThriving, setNetThriving] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!opened) {
      setNetThriving([]);
      setPage(1);
      setLoading(true);

      return;
    }

    (async () => {
      setLoading(true);
      try {
        const response = await TeamService.getNetThrivingScoreStatsDetails(
          team_id,
          page
        );
        setNetThriving(
          Array.from(new Set([...netThriving, ...response.data.data]))
        );
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();
    // eslint-disable-next-line
  }, [opened, team_id, page]);

  if (!opened) {
    return <Loader loaderStyle={classes.loaderStyle} />;
  }

  const LoadingContainer = (
    <>
      {loading && (
        <h4 style={{ display: "flex", justifyContent: "center" }}>
          <Loader loaderStyle={classes.LoaderStyle} />
        </h4>
      )}
    </>
  );
  return (
    <div className="netThrivingDetailsContainer">
      <div className="detailCardContainer netThrivingDetailContainer">
        <EngagementPoint />

        <NetThrivingScoreStatsHeaderCard stats={stats} />
        <Scrollbar>
          <NetThrivingScoreStatsDetailsPerUser netThriving={netThriving} />
          {LoadingContainer}
        </Scrollbar>
      </div>
    </div>
  );
};
